'use client';

import Icon from './Icon';
import svg from 'sprites/filter.svg';

export default function IconFilter({
  className = 'w-[21px] h-[14px] fill-none stroke-current'
}: {
  className?: string;
}) {
  return <Icon id={svg.id} className={className} />;
}
